<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 11:31:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 13:35:38
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="selection-decoration main-content-padding">
		<Panel :contentPaddingTop="12" class="pallet">
			<div class="right-btn flex flex-align-center">
				<ButtonGroup>
					<div class="yx-color-text-p-4 cursor-pointer hover mt-6" @click="openFunDesc">
						<i class="el-icon-notebook-2 fz-14"></i>
						<span class="fz-12 ml-6">功能说明</span>
					</div>
				</ButtonGroup>
				<ButtonGroup>
					<el-tooltip class="item" effect="dark" content="视频号暂未开放" :disabled="!$isSp()" placement="top">
						<div class="yx-color-text-p-4 cursor-pointer mt-6" :class="{ hover: $isSp() }" @click="openSelectCenter">
							<i class="el-icon-shopping-cart-2 fz-14"></i>
							<span class="fz-12 ml-6">选品中心</span>
						</div>
					</el-tooltip>
				</ButtonGroup>
			</div>
			<platformTab @change="handleClick" :showAll="false" :platformId="platformId"></platformTab>

			<template v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
				<div class="mt-10 mb-24" v-show="showPlatformContent">
					<SubTabs @tab-click="handleTabClick" v-model="activeName" :list="tabList">
						<template slot-scope="{ item }">{{ item.label }}</template>
					</SubTabs>
				</div>
				<div class="btn flex flex-align-center" v-show="showPlatformContent">
					<ButtonGroup :paddingRight="0" v-if="btnText">
						<el-button type="primary" @click="addList" :disabled="isDisableBtn">{{ btnText }}</el-button>
						<span class="yx-color-pure-1 font-h4-regular ml-16 mt-2" v-if="AddNum">(已添加 {{ list.length }}/{{ AddNum }})</span>
					</ButtonGroup>
					<ButtonGroup v-if="isShowSelectCenter">
						<div class="flex flex-align-center mt-2">
							<span class="yx-color-pure-1 font-h4-regular">在选品小程序展示</span>
							<el-switch
								v-model="isOpen"
								class="ml-8"
								@change="changeSwitch"
								inactive-color="#E2E3E8"
								active-value="1"
								inactive-value="0"
							></el-switch>
							<explain
								icon="el-icon-question yx-color-text-placeholder"
								size="14"
								content="关闭后该模块将不在小程序选品中心展示"
								class="ml-10"
							></explain>
						</div>
					</ButtonGroup>
				</div>
				<div class="mt-12" v-show="showPlatformContent">
					<multi-table
						:distanceTop="activeName !== '4' ? 10 : 65"
						:showPager="activeName === '4'"
						ref="multiTable"
						:columns="columns"
						@gePartnerList="tabGetList"
						:list="list"
						:total="total"
						v-loading="loading"
					>
						<empty ref="empty" slot="empty"></empty>
					</multi-table>
				</div>
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="$isPlatOr(platformId, ['Sp']) ? 'sph-main' : ''" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
		<!-- 功能描述 -->
		<fun-desc ref="funDesc" />

		<!-- 新增banner配置及金刚位 -->
		<bannerDrawer ref="bannerDrawer" @refresh="getList" :platformId="platformId" />

		<!-- 新增集合页 -->
		<addCollectionDrawer ref="addCollectionDrawer" :platformId="platformId" @refresh="getList" />

		<!-- 编辑橱窗样式 -->
		<showcaseStyleDrawer ref="showcaseStyleDrawer" :platformId="platformId" @refresh="getList" />

		<!-- 删除弹框 -->
		<del-dialog ref="delDialog" @refresh="getList" :platformId="platformId" />

		<!-- 预览弹框 -->
		<preview-dialog ref="previewDialog" />
	</div>
</template>
<script>
import { bannerColumns, JGColumns, showcaseColumns, collectionColumns } from './columns';
import empty from '@/views/common/empty/index.vue';
import { platformMixin } from '@rd/rd-ui';
import { mapGetters } from 'vuex';
import ButtonGroup from '@/components/ui/buttonGroup';
import Explain from '@/components/common/explain';
import funDesc from './components/funDesc';
import bannerDrawer from './components/bannerDrawer';
import addCollectionDrawer from './components/addCollectionDrawer';
import showcaseStyleDrawer from './components/showcaseStyleDrawer';
import delDialog from './components/delDialog';
import previewDialog from './components/previewDialog';
import { productGatherList, bannerList, showCaseList, iconsList, setTpl } from '@/api/selectionDecoration';
import SubTabs from '@/components/ui/subTabs/index.vue';
export default {
	name: 'index',
	components: {
		empty,
		ButtonGroup,
		Explain,
		funDesc,
		bannerDrawer,
		addCollectionDrawer,
		showcaseStyleDrawer,
		delDialog,
		previewDialog,
		SubTabs,
	},
	mixins: [platformMixin],
	provide() {
		return {
			refresh: this.getList,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		columns({ activeName }) {
			const obj = {
				1: bannerColumns,
				2: JGColumns,
				3: showcaseColumns,
				4: collectionColumns,
			};
			return obj[activeName];
		},
		// 按钮文字
		btnText({ activeName }) {
			const obj = {
				1: '新增banner',
				2: '新增金刚位',
				3: '',
				4: '新增集合页',
			};
			return obj[activeName];
		},
		// 添加的最大数量
		AddNum({ activeName }) {
			const obj = {
				1: 10,
				2: 5,
				3: undefined, //不限制
				4: undefined, //不限制
			};
			return obj[activeName];
		},
		// 按钮是否禁用
		isDisableBtn({ AddNum, list }) {
			return list.length >= AddNum;
		},
		//是否展示在选品中心展示
		isShowSelectCenter({ activeName }) {
			const obj = {
				1: true,
				2: true,
				3: true,
				4: false,
			};
			return obj[activeName];
		},
	},
	created() {
		this.getList();
	},
	data() {
		return {
			activeName: '1',
			tabList: Object.freeze([
				{ label: 'banner配置', name: '1' },
				{ label: '金刚位配置', name: '2' },
				{ label: '橱窗配置', name: '3' },
				{ label: '集合页配置', name: '4' },
			]),
			list: [],
			total: 0,
			pageInfo: {
				page: 1,
				pageSize: 10,
			},
			isOpen: 0,
			loading: false,
		};
	},
	methods: {
		async getList() {
			const { activeName, platformId } = this;
			const api = this.getApi();
			const params = this.getParams();
			this.loading = true;
			try {
				const data = await api(params);
				this.isOpen = data.isOpen;
				this.list = data.list.map(item => ({
					...item,
					activeName,
					platformId,
					operations: this.getButtons(item),
				}));
				this.total = data.page?.itemTotal;
				this.loading = false;
			} finally {
				this.loading = false;
			}
		},
		getApi() {
			const { activeName } = this;
			const api = {
				1: bannerList,
				2: iconsList,
				3: showCaseList,
				4: productGatherList,
			};
			return api[activeName];
		},
		getParams() {
			const { activeName, platformId } = this;
			const params = {
				1: {
					platformId,
				},
				2: {
					platformId,
				},
				3: {
					platformId,
				},
				4: {
					platformId,
					...this.pageInfo,
				},
			};
			return params[activeName];
		},
		addList(row = {}) {
			const { activeName } = this;
			const obj = {
				1: this.$refs.bannerDrawer.show,
				2: this.$refs.bannerDrawer.show,
				3: this.$refs.showcaseStyleDrawer.show,
				4: this.$refs.addCollectionDrawer.show,
			};
			const { title, link, id } = row;
			const params1 = {
				1: 'banner',
				2: 'jg',
				3: row.type,
				4: '',
			};
			const params2 = {
				1: row,
				2: row,
				3: { title, locationList: row.locationList },
				4: { link, groupTitle: row.groupTitle, title, imageUrl: row.imageUrl, id },
			};
			obj[activeName](params1[activeName], params2[activeName]);
		},
		async changeSwitch(e) {
			this.isOpen = e === '1' ? '0' : '1';
			const { activeName: tplType, platformId } = this;
			await setTpl({ tplType, status: e, platformId });
			this.$message.success('操作成功！');
			this.isOpen = e === '1' ? '1' : '0';
			this.getList();
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.reset();
			this.getList();
		},
		handleTabClick(tab, event) {
			this.reset();
			this.getList();
		},
		getButtons() {
			const { activeName } = this;
			const edit = {
				label: '编辑',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: row => {
					this.addList(row);
				},
			};
			const preview = {
				label: '预览',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: ({ platformId, id }) => {
					this.openPreview({ preview: 'preview_goods', platformId, link: id, linkType: '2' });
				},
			};
			const det = {
				label: '删除',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: row => {
					this.$refs.delDialog.show(row.id, activeName);
				},
			};
			const obj = {
				1: [edit, det],
				2: [edit, det],
				3: [edit],
				4: [edit, preview, det],
			};
			const arr = obj[activeName];
			let filterArr = arr.filter(item => item.isShow);
			filterArr.getList = this.getList;
			filterArr.openPreview = this.openPreview;
			return filterArr;
		},
		openFunDesc() {
			this.$refs.funDesc.show();
		},
		reset() {
			this.pageInfo = {
				page: 1,
				pageSize: 10,
			};
		},
		openSelectCenter() {
			const { platformId } = this;
			if (this.$isSp()) {
				return;
			}
			this.openPreview({ preview: 'preview_center', platformId });
		},
		sizeChange(val) {
			this.pageInfo.pageSize = val;
			this.getList();
		},
		openPreview(params) {
			this.$refs.previewDialog.show(params);
		},
		currentChange(val) {
			this.pageInfo.page = val;
			this.getList();
		},
		tabGetList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page = page_index;
			this.pageInfo.pageSize = page_size;
			this.getList();
		},
	},
};
</script>
<style lang="less" scoped>
.selection-decoration {
	::v-depp .el-button {
		border-radius: 4px;
	}
	.right-btn {
		position: absolute;
		top: 17px;
		right: 24px;
		z-index: 999;
	}
}
.sph-main {
	height: calc(100vh - 295px);
}
</style>
